// extracted by mini-css-extract-plugin
export default {"cpvValue":"styles_cpvValue__Zrn8y","cpvViews":"styles_cpvViews__9LbTu"};